import React, { FC, useMemo } from 'react';
import { Avatar, AvatarProps } from 'antd';
import classNames from 'classnames';

type Props = AvatarProps & {
  user: any;
};

const colors = [
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F7F7F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C5B0D5',
  '#C49C94',
  '#F7B6D2',
  '#C7C7C7',
  '#DBDB8D',
  '#9EDAE5',
  '#393B79',
  '#637939',
  '#8C6D31',
  '#843C39',
  '#7B4173',
  '#5254A3',
  '#8CA252',
  '#BD9E39',
  '#AD494A',
  '#A55194',
  '#6B6ECF',
  '#B5CF6B',
];

function getAvatarColor(firstName: string, lastName: string) {
  // Helper function to calculate the sum of ASCII values
  function asciiSum(str: string) {
    return str.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  }

  const totalSum = asciiSum(firstName) + asciiSum(lastName);
  const colorIndex = totalSum % colors.length;
  return colors[colorIndex];
}

// Example usage:
const firstName = 'John';
const lastName = 'Doe';
const avatarColor = getAvatarColor(firstName, lastName);
console.log(avatarColor); // Outputs the corresponding color from the array

export const UserAvatar: FC<Props> = (props) => {
  const backgroundColor = useMemo(() => {
    if (props.user?.picture) {
      return 'white';
    }
    return getAvatarColor(
      props.user?.firstName ?? '',
      props.user?.lastName ?? '',
    );
  }, [props.user?.firstName, props.user?.lastName, props.user?.picture]);
  return (
    <Avatar
      {...props}
      src={props.user?.picture}
      className={classNames('shrink-0 grow-0', props.className)}
      style={{ backgroundColor }}
    >
      {props.user?.name
        .split(' ')
        .splice(0, 2)
        .map((n: string) => n.substring(0, 1))
        .join('')}
    </Avatar>
  );
};
